import { SortDirection } from "@redotech/redo-model/tables/table";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const getRecoverConversationLogs = {
  name: "getRecoverConversationLogs" as const,
  input: z.object({
    page: z.number().int().positive().default(1),
    pageSize: z.number().int().positive().max(100).default(20),
    sortKey: z
      .enum(["lastMessageAt", "lastInitialMessageAt", "messageCount"])
      .default("lastMessageAt"),
    sortDirection: createEnum(SortDirection).default(SortDirection.DESC),
    searchString: z.string().optional(),
  }),
  output: z.object({
    conversations: z.array(
      z.object({
        _id: z.string(),
        customerName: z.string().optional(),
        lastMessageAt: z.date(),
        lastInitialMessageAt: z.date().optional(),
        messageCount: z.number(),
      }),
    ),
    totalCount: z.number(),
  }),
};
